import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

const Types = () => {
  return (

<div>
<Navbar/>

<br />
<br />
<br />
<br />

        <div className="text-center mt-10">
            <h2 className="text-3xl font-bold leading-tight text-gray-900 sm:text-2xl xl:text-5xl font-pj">रोग चयन: अपने स्वास्थ्य की देखभाल करें विशेष रूप से</h2>
            <p className="mt-4 ml-10 mr-10  text-xl leading-7 text-gray-600 sm:mt-8 font-pj">आपके स्वास्थ्य की देखभाल में हमें यह जानना महत्वपूर्ण है कि आप किस प्रकार के रोग से प्रभावित हो रहे हैं ताकि हम आपकी जीवनशैली और आवश्यकताओं के अनुसार आपको बेहतर ढंग से सेवा प्रदान कर सकें। कृपया नीचे दिए गए विकल्पों में से अपना चयन करें ताकि हम आपको विशेष रूप से ध्यान देने में सक्षम हों:</p>
        </div>
<div className='flex justify-center flex-wrap  '>

<div className=' flex m-10 flex-wrap justify-center sm: flex-col-1'>

<div class="relative flex flex-col  m-6 text-gray-700 bg-blue-300 shadow-md bg-clip-border rounded-xl w-96">
  <div
    class="relative h-56 mx-4 -mt-6 overflow-hidden text-white shadow-lg bg-clip-border rounded-xl bg-blue-gray-500 shadow-blue-gray-500/40">
    <img
      src="https://images.unsplash.com/photo-1540553016722-983e48a2cd10?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=800&amp;q=80"
      alt="card-image" />
  </div>
  <div class="p-6">
    <h5 class="block b mb-2 font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
    सामान्य रोगी
    </h5>
    <p class="block font-sans text-base antialiased font-light leading-relaxed text-inherit">
    यहां, आप अपनी सामान्य स्वास्थ्य स्थिति और इतिहास को विस्तृत रूप से दर्ज कर सकते हैं। आपकी सामान्य चेकअप से लेकर गुणवत्ता को सुनिश्चित करने तक, हम आपके सामान्य स्वास्थ्य की सम्पूर्ण छवि प्राप्त करने के लिए यह जानना चाहते हैं।
    </p>
  </div>
  <div class="p-6 pt-0">
    <button
      class="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
      type="button">
      <a href='https://forms.gle/CXL4ub2RkZPLvLtw6' target="_blank" >click here </a>
    </button>
  </div>
</div>  

<div class="relative flex flex-col m-6 text-gray-700 bg-blue-300 shadow-md bg-clip-border rounded-xl w-96">
  <div
    class="relative h-56 mx-4 -mt-6 overflow-hidden text-white shadow-lg bg-clip-border rounded-xl bg-blue-gray-500 shadow-blue-gray-500/40">
    <img
      src="https://images.unsplash.com/photo-1540553016722-983e48a2cd10?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=800&amp;q=80"
      alt="card-image" />
  </div>
  <div class="p-6">
    <h5 class="block mb-2 font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
    हृदय रोगी
    </h5>

    <p class="block font-sans text-base antialiased font-light leading-relaxed text-inherit">
    इस खंड में, आप अपने हृदय से संबंधित सभी जानकारी को नोट कर सकते हैं, जैसे कि हृदय रोग के इतिहास, इलाज की स्थिति, और नियमित जांचों का समय।
    </p>
  </div>
  <br />
  <br />
  <div class="p-6 pt-0">
    <button
      class="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
      type="button">

<a href='https://forms.gle/gTbGJMSpdStapcb78' target="_blank" >click here </a>
    </button>
  </div>
</div>

<div class="relative flex flex-col m-6 text-gray-700 bg-blue-300 shadow-md bg-clip-border rounded-xl w-96">
  <div
    class="relative h-56 mx-4 -mt-6 overflow-hidden text-white shadow-lg bg-clip-border rounded-xl bg-blue-gray-500 shadow-blue-gray-500/40">
    <img
      src="https://images.unsplash.com/photo-1540553016722-983e48a2cd10?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=800&amp;q=80"
      alt="card-image" />
  </div>
  <div class="p-6">
    <h5 class="block mb-2 font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
    डायबीटिक रोगी
    </h5>
    <p class="block font-sans text-base antialiased font-light leading-relaxed text-inherit">
    इस भाग में, आप अपने डायबीटीज़ से संबंधित जानकारी को दर्ज कर सकते हैं, जैसे कि रोग का प्रकार, रोग की गति, और रोग के नियंत्रण के लिए आपकी वर्तमान चिकित्सा की स्थिति।
    </p>
  </div>
  <br />
  <div class="p-6 pt-0">
    <button 
      class="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
      type="button"><a href='https://forms.gle/shhvdDd8Uqt5wNka7' target="_blank" >click here </a>
      
    </button>
  </div>
</div>  

</div>

<div className='flex m-10 flex-wrap justify-center  '>

<div class="relative flex flex-col m-6 text-gray-700 bg-blue-300 shadow-md bg-clip-border rounded-xl w-96">
  <div
    class="relative h-56 mx-4 -mt-6 overflow-hidden text-white shadow-lg bg-clip-border rounded-xl bg-blue-gray-500 shadow-blue-gray-500/40">
    <img
      src="https://images.unsplash.com/photo-1540553016722-983e48a2cd10?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=800&amp;q=80"
      alt="card-image" />
  </div>
  <div class="p-6">
    <h5 class="block mb-2 font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
    वजन बढ़ाना / घटाना रोगी
    </h5>
    <p class="block font-sans text-base antialiased font-light leading-relaxed text-inherit">
    इस खंड में, आप अपने वजन बढ़ाने या घटाने के लक्षणों, इतिहास, और वर्तमान दिनचर्या को समझने के लिए जानकारी दर्ज कर सकते हैं, जिससे हम आपको विशेषज्ञ योजना प्रदान कर सकते हैं।
    </p>
  </div>
  <div class="p-6 pt-0">
    <button
      class="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
      type="button">
      <a href='https://forms.gle/CXL4ub2RkZPLvLtw6' target="_blank" >click here </a>
    </button>
  </div>
</div>  

<div class="relative flex flex-col m-6 text-gray-700 bg-blue-300 shadow-md bg-clip-border rounded-xl w-96">
  <div
    class="relative h-56 mx-4 -mt-6 overflow-hidden text-white shadow-lg bg-clip-border rounded-xl bg-blue-gray-500 shadow-blue-gray-500/40">
    <img
      src="https://images.unsplash.com/photo-1540553016722-983e48a2cd10?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=800&amp;q=80"
      alt="card-image" />
  </div>
  <div class="p-6">
    <h5 class="block mb-2 font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
    चिंता या हाइपरटेंशन रोगी
    </h5>
    <p class="block font-sans text-base antialiased font-light leading-relaxed text-inherit">
      The place is close to Barceloneta Beach and bus stop just 2 min by walk
      and near to "Naviglio" where you can enjoy the main night life in
      Barcelona.
    </p>
  </div>
  <div class="p-6 pt-0">
    <button
      class="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
      type="button">
      <a href='https://forms.gle/CXL4ub2RkZPLvLtw6' target="_blank" >click here </a>
    </button>
  </div>
</div>  

<div class="relative flex flex-col m-6 text-gray-700 bg-blue-300 shadow-md bg-clip-border rounded-xl w-96">
  <div
    class="relative h-56 mx-4 -mt-6 overflow-hidden text-white shadow-lg bg-clip-border rounded-xl bg-blue-gray-500 shadow-blue-gray-500/40">
    <img
      src="https://images.unsplash.com/photo-1540553016722-983e48a2cd10?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=800&amp;q=80"
      alt="card-image" />
  </div>
  <div class="p-6">
    <h5 class="block mb-2 font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
    सेक्सुअल समस्या रोगी
    </h5>
    <p class="block font-sans text-base antialiased font-light leading-relaxed text-inherit">
    इस खंड में, आप अपनी सेक्सुअल स्वास्थ्य से संबंधित समस्याओं और उनके समाधान को समझने के लिए अपने इतिहास को विवरण से भर सकते हैं। हम आपको उपयुक्त और प्रभावी उपाय प्रदान करने के लिए यह जानना चाहते हैं।
    </p>
  </div>
  <div class="p-6 pt-0">
    <button
      class="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
      type="button">
      <a href='https://forms.gle/CXL4ub2RkZPLvLtw6' target="_blank" >click here </a>
    </button>
  </div>
</div>

</div>
 

</div>

<Footer/>
      
</div>
  )
}

export default Types
